export default "__VITE_ASSET__v92HvmmH__"